import React from "react";

export const FullScreenContext = React.createContext({
  fullScreen: false,
  toggleFullScreen: () => {},
});